import { SHORT_FORM_CONTEST_RESULT_ARR } from "@/constants/staticInformation";
import { mq } from "@/libs/react-responsive/mediaQuery";
import { color, image } from "@/theme";
import styled from "@emotion/styled";
import React from "react";

const StyledImage = styled.img(() => ({
  display: "block",
  maxWidth: "100%",
  margin: "0 auto",

  [mq("tablet")]: {
    maxWidth: "90%",
  },
}));

const Title = styled.div(() => ({
  width: "100%",
  padding: "1rem 0",
  background: color.primary01,
  textAlign: "center",
  color: "white",
  marginTop: "5rem",
  whiteSpace: "pre-line",
}));

const InfoList = styled.ul(() => ({
  width: "100%",
  marginTop: "8rem",
  fontSize: "2.4rem",
}));

const InfoItem = styled.ul(() => ({
  display: "flex",
  flexDirection: "column",
  fontSize: "1.6rem",
  borderBottom: `1px solid ${color.grey04}`,

  [mq("tablet")]: {
    flexDirection: "row",
  },

  [mq("desktop")]: {
    flexDirection: "row",
    fontSize: "2.4rem",
  },

  small: {
    display: "block",
    fontSize: "1.4rem",

    [mq("tablet")]: {
      fontSize: "1.4rem",
    },

    [mq("desktop")]: {
      fontSize: "2rem",
    },
  },
}));

const InfoContent = styled.div(({ isBold }) => ({
  flex: 1,
  padding: "1rem 0 1rem 1rem",
  color:
    isBold === true
      ? color.primary02
      : isBold === false
        ? color.grey06
        : color.black01,

  ul: {
    lineHeight: 1.5,
    fontSize: "1.6rem",
    marginBottom: "1.2rem",

    [mq("tablet")]: {
      fontSize: "1.6rem",
    },

    [mq("desktop")]: {
      fontSize: "2.2rem",
    },
  },

  ".sns-link": {
    marginBlock: "1.6rem",
  },
}));

const InfoTitle = styled.header(({ theme, isBold }) => ({
  width: "100%",
  textAlign: "left",
  padding: ".6rem 1rem",
  borderBottom: `1px dashed #F5F5F5`,
  letterSpacing: "0.2rem",
  marginRight: "0.4rem",
  fontWeight: 700,

  color:
    isBold === true
      ? color.primary02
      : isBold === false
        ? color.grey06
        : color.black01,

  [mq("tablet")]: {
    width: "16rem",
    textAlign: "center",
    padding: "1rem 0",
    fontWeight: 400,
    borderRight: `1px solid ${theme.color.grey04}`,
    borderBottom: "none",
  },

  [mq("desktop")]: {
    width: "24rem",
  },
}));

const ShortFormCampaignDetail = () => {
  return (
    <section>
      <StyledImage src={image.campaignPoster01} alt="campaign-poster" />

      <InfoList>
        {SHORT_FORM_CONTEST_RESULT_ARR.map(info => {
          return (
            <InfoItem key={info.title}>
              {info.isTitle ? (
                <Title>{info.title}</Title>
              ) : (
                <InfoTitle>{info.title}</InfoTitle>
              )}

              {info.content && <InfoContent>{info.content}</InfoContent>}
            </InfoItem>
          );
        })}
      </InfoList>
    </section>
  );
};

export default ShortFormCampaignDetail;
